import { createFileRoute } from '@tanstack/react-router';
import { SsoTenantLogin } from '../../components';

export const Route = createFileRoute('/sso/$tenant')({
  component: SsoTenantWithRouteParam,
});

function SsoTenantWithRouteParam() {
  const params = Route.useParams();
  const navigate = Route.useNavigate();

  return <SsoTenantLogin<`/sso/$tenant`> {...{ navigate, tenant: params.tenant }} />;
}
